import { AccommodationsOnRegistryConfirmation } from './AccommodationsOnRegistryConfirmation';
export default AccommodationsOnRegistryConfirmation;
